/*
 * @Author: dingguowei
 * @Date: 2023-05-18 11:26:03
 * @LastEditors: dingguowei
 * @LastEditTime: 2023-05-29 16:12:28
 */
import request from '@/plugins/axios'
const base = '/'

export function getMxJdOrder(params) {
  return request({
    url: base + 'api/jd/cworderId/mx/get',
    method: 'get',
    params
  })
}


export function getLgJdOrder(params) {
  return request({
    url: base + 'api/jd/orderId/lg/cwget',
    method: 'get',
    params
  })
}